export const updateNavigation = ({ commit }, navigation) => {
  commit('UPDATE_NAVIGATION', navigation)
}



// WEBPACK FOOTER //
// ./doc/store/actions.js